import React from 'react';
import PropTypes from 'prop-types';

import styles from './RacingThemeSearchFilterChip.module.css';

/**
 * Active search filter chip.
 */
const RacingThemeSearchFilterChip = props => {
  const { label, department = null, onRemove } = props;

  return (
    <span className={styles.filterChip} data-department={department || undefined}>
      {label}
      <button
        type="button"
        className={styles.filterChipRemove}
        aria-label={`Remove ${label} filter`}
        onClick={onRemove}
      >
        <svg width="8" height="8" viewBox="0 0 8 8" aria-hidden="true">
          <path
            d="M1.5 1.5l5 5M6.5 1.5l-5 5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </span>
  );
};

RacingThemeSearchFilterChip.propTypes = {
  label: PropTypes.string.isRequired,
  department: PropTypes.oneOf(['shop', 'book', 'partner']),
  onRemove: PropTypes.func,
};

export default RacingThemeSearchFilterChip;
